module.exports = __webpack_public_path__ + "static/media/blog10.4b5f8dbc.webp";